<template>
  <div class="feature-grid" :class="{ light }">
    <div class="block-content">
      <block-title :en="section.title.en" :title="section.title.value" :sub="section.title.sub"></block-title>
      <div class="card-list" :style="gridStyle">
        <div class="card-item" v-for="item in section.list" :key="item.title">
          <img class="card-icon" :src="item.icon" alt="" />
          <div class="card-content">
            <div class="card-title">{{ item.title }}</div>
            <div class="card-description">{{ item.description }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    dataKey: {
      type: String,
      default: ''
    },
    sectionKey: {
      type: String,
      default: ''
    },
    light: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['globalData']),
    section() {
      return this.globalData[this.dataKey]?.[this.sectionKey] || { title: {}, list: [] };
    },
    gridStyle() {
      const columns = this.section.list.length || 1;

      return {
        gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.feature-grid {
  padding: 80px 0;
  background: #ffffff;

  * {
    box-sizing: border-box;
  }

  &.light {
    background: #f5f9ff;
  }
}

.card-list {
  display: grid;
  gap: 24px;
  margin-top: 60px;
}

.card-item {
  overflow: hidden;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
}

.card-icon {
  display: block;
  width: 100%;
  height: 260px;
  object-fit: cover;
}

.card-content {
  padding: 24px;
  min-height: 180px;
}

.card-title {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 700;
  font-size: 24px;
  color: #333333;
  line-height: 34px;
  text-align: left;
}

.card-description {
  margin-top: 16px;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 16px;
  color: #909399;
  line-height: 30px;
  text-align: left;
}
</style>
